var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section-indicators" }, [
    _c("a", { attrs: { href: "#" + _vm.anchor } }, [
      _c("i", { staticClass: "fas fa-angle-down" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib?{}!./scripts/vue/components/ui/SectionIndicators.vue?vue&type=template&id=702fd523&
// module id = 450
// module chunks = 1